<template>
  <div
    style="flex: 1 1 0%; width: 100%; border: 0px; justify-content: flex-start; padding:10px 30px 10px 08px;"
    class="mx-2"
    
  >
    <!-- Loading indicator -->
    <div v-if="isLoading" class="text-center py-4">
      <v-progress-circular indeterminate color="primary" size="32" />
      <p>Loading...</p>
    </div>

    <!-- Existing content -->
    <div v-if="!isLoading">
      <div v-if="!claim.DSSClaimsID " class="text-center mt-4">
        please select conversation
      </div>

      <!-- thread list -->
      <div v-if="showallthreadconvos" class="thread-list">
        <div
          v-for="convo in simplifiedThreadConvos"
          :key="convo.convo_id"
          class="thread-item"
          :class="{ 'highlight-thread': convo.highlight }"
          @click="openConvo(convo)"
        >
          <span class="convo-name">{{ convo.convo_name }}</span>

          <v-tooltip
            v-if="convo.convo_reminders && convo.convo_reminders.length > 0"
            location="top"
            :text="getReminderTooltip(convo.convo_reminders)"
          >
            <template #activator="{ props }">
              <div
                class="reminder-container"
                v-bind="props"
                @click.stop
              >
                <v-icon
                  :color="
                    convo.reminderStatus === 'green'
                      ? 'green'
                      : convo.reminderStatus === 'red'
                      ? 'red'
                      : 'grey'
                  "
                >
                  mdi-alarm
                </v-icon>
              </div>
            </template>
          </v-tooltip>
        </div>

        <div v-if="showallthreads">
          <button
            @click="toggleShowAllThreads"
            class="show-all-convos-btn"
          >
            Show All Convos
          </button>
        </div>

        <div v-if="claim.DSSClaimsID && simplifiedThreadConvos.length === 0">
          No Thread Message
        </div>
      </div>

      <!-- thread view -->
      <div v-else class="w-full">
        <!-- Back Button -->
        <div
          @click="backToThreadList"
          style="display:flex; align-items:center; cursor:pointer; margin-bottom:10px;"
        >
          <i class="fas fa-arrow-left" style="font-size:20px; margin-right:8px;"></i>
          <v-icon>mdi-arrow-left</v-icon>
        </div>

        <!-- parent preview -->
        <div
          class="attachment-participant-row"
          v-if="displayItems.length || (participants && participants.length)"
        >
         

          <!-- CENTERED ATTACHMENTS -->
          <div class="attachments-center">
           <v-tooltip 
  v-if="(selectedConvo.owner == userId || isAdmin) && selectedConvo.convo_status !== false"
  location="top" 
  text="Close this conversation"
>
  <template #activator="{ props }">
    <v-icon 
      v-bind="props"
      @click="deleteConvo(selectedConvo)"
      class="ml-2"
      color="red"
    >
      mdi-close-octagon
    </v-icon>
  </template>
</v-tooltip>
            <div
              v-for="(item, i) in displayItems"
              :key="i"
              class="attachment-box"
            >
              <img
                v-if="item.contentType === 'image'"
                :src="item.url"
                class="attachment-img"
                @click="openImg(item.url)"
              />

              <a
                v-else-if="item.contentType === 'pdf'"
                :href="item.url"
                target="_blank"
                class="attachment-pdf"
              >
                <v-icon color="red" size="20">mdi-file-pdf-box</v-icon>
                View PDF
              </a>

              <AudioPlayer
                v-else-if="item.contentType === 'audio'"
                :src="item.url"
              />

              <video
                v-else-if="item.contentType === 'video'"
                class="attachment-video"
                controls
                :src="item.url"
              ></video>

              <div v-if="item.contentType === 'text'">
                {{ item.text }}
              </div>
            </div>
          </div>

          <!-- RIGHT SIDE: PARTICIPANTS -->
          <div class="participants-right" v-if="participants && participants.length">
            <div class="participants-row">
              <div
                v-for="user in participants"
                :key="user.user_id"
                class="participant-avatar"
              >
                <UserPopup
                  :user_id="user.user_id"
                  :badge="getReminder(user.user_id) ? true : false"
                  :dense="true"
                >
                  <template v-slot:badge>
                    <v-tooltip
                      location="top"
                      :text="
                        dayjs(
                          getReminder(user.user_id)?.reminder_date
                        ).format('h:mmA M/D/YYYY')
                      "
                    >
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props">mdi-alarm</v-icon>
                      </template>
                    </v-tooltip>
                  </template>
                </UserPopup>
              </div>
            </div>

            <div class="participants-label">
              <v-icon size="small">mdi-account-multiple</v-icon>
              Participants
            </div>
          </div>
        </div>

        <v-divider style="margin-top: 10px" />

        <!-- messages scroller -->
        <div style="width: 100%; height: 50vh;">
          <DynamicScroller
            :items="internalMessages"
            :minItemSize="60"
            key-field="convo_message_id"
            style="height: 100%; margin-top: 20px"
            ref="scroller"
          >
            <template v-slot="{ item, index, active }">
              <DynamicScrollerItem v-if="item" :item="item" :active="active">
                <div :id="`message-${item.convo_message_id}`">
                  <Message
                    :index="index"
                    :prev="index === 0 ? null : internalMessages[index - 1]"
                    :active="active"
                    :message="item"
                    :refrenceConvo="getReferenceMessage(item.ref)"
                    @reference-click="scrollToReference"
                  />
                </div>
              </DynamicScrollerItem>
            </template>
          </DynamicScroller>
        </div>

        <!-- input / convo box -->
        <div style="display: flex; width: 100%; padding-bottom: var(--safe-area-inset-bottom);">
          <ConvoBox
            :convo="selectedConvo"
            @threadconvo="threadconvo($event)"
            @threadcloseConvo="threadcloseConvo"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { DynamicScroller, DynamicScrollerItem } from "vue-virtual-scroller";

import Message from "@/components/Messenger/Message.vue";
import ConvoBox from "@/components/FrontDesk/RightPanel/ConvoBox.vue";
import AudioPlayer from "@/components/UIComponents/AudioPlayer.vue";
import dayjsMixin from "@/mixins/dayjsMixin";
import eventBus from "../../../eventBus";
import ConvoService from "@/services/convoService";
import { mapMutations } from "vuex/dist/vuex.cjs.js";
import UserPopup from "../.././Avatar/UserPopup.vue";

export default {
  name: "Rightpanel",
  mixins: [dayjsMixin],
  components: {
    DynamicScroller,
    DynamicScrollerItem,
    Message,
    ConvoBox,
    AudioPlayer,
    UserPopup,
  },

  data() {
    return {
      displayItems: [],
      resolvedUrls: {},
      selectedConvo: {},
      internalMessages: [],
      showallthreadconvos: false,
      message_thread: null,
      showallthreads: false,
    };
  },

watch: {
  claim: {
    deep: true,
    immediate: true,
    async handler() {
      try {
        this.RESET_THREADCONVO_STATE();
        await this.fetchThreadConvos();
        this.showallthreadconvos = true;
        this.showallthreads = true; // ensures button + list state sync
        this.selectedConvo = {};
        await this.$nextTick();
      } catch (e) {
        console.error("Error loading internal threads:", e);
      }
    },
  },


  // THIS MUST BE OUTSIDE claim watcher
 threadMessagesFromStore: {
    immediate: true,
    handler(newVal) {
      if (!this.selectedConvo?.convo_id) return;
      if (Array.isArray(newVal)) {
        // Always create a fresh array so virtual scroller notices changes
        // Filter out items with null convo_message_id — DynamicScroller requires a non-null key
        this.internalMessages = newVal.filter(m => m.convo_message_id != null);
        this.$nextTick(() => {
          try {
            if (this.$refs.scroller && this.internalMessages.length) {
              this.$refs.scroller.scrollToItem(this.internalMessages.length - 1);
            }
          } catch (e) {
            console.warn("[RightPanel] scrollToItem (watcher) failed:", e);
          }
        });
      }
    }
  },
}
,

  computed: {
    ...mapGetters(['isAdmin']),
    ...mapGetters(["userId"]),
    ...mapGetters("osclaims", ["claim"]),
    ...mapGetters("threadconvo", [
      "getcreatethreaddata",
      "simplifiedThreadConvos",
      "isLoading",
      "getSingleThread",
      "getParticipantsByConvoId",
      "getThreadMessages","isfilter"
    ]),

    participants() {
      const id = this.selectedConvo?.convo_id;
      return id ? this.getParticipantsByConvoId(id) : [];
    },
      threadMessagesFromStore() {
    const id = this.selectedConvo?.convo_id;
    if (!id) return [];
    // call getter which returns a slice already; ensure we copy again
    return this.getThreadMessages(id).slice();
  },

  },

  methods: {
    ...mapActions("convos", ["getInternalMessages"]),
    ...mapActions("threadconvo", ["createConvo", "fetchThreadConvos"]),
    ...mapMutations("convos", ["setInternalConvos"]),
    ...mapMutations("threadconvo", ["RESET_THREADCONVO_STATE","PARENTTHREADDATA","SHOWCONVORIGHTPANEL", "SET_THREAD_FILTER"]),

    openImg(url) {
      if (url) window.open(url, "_blank");
    },

    toggleShowAllThreads() {
      this.showallthreads = !this.showallthreads;
      this.SET_THREAD_FILTER(null);
    },

    getReminder(participant_id) {
      if (!this.selectedConvo?.convo_reminders?.length) return false;
      return (
        this.selectedConvo.convo_reminders.find(
          (r) => r.reminder_for_who === participant_id
        ) || false
      );
    },

    async fetchAndStoreUrl(convo_message_id, media_id, content_type) {
      try {
        const res = await ConvoService.getConvoMediaUrl(
          convo_message_id,
          media_id
        );
        const url = res;

        let type = "image";
        if (content_type?.includes("pdf")) type = "pdf";
        else if (content_type?.includes("audio")) type = "audio";
        else if (content_type?.includes("video")) type = "video";

        this.displayItems = [{ url, contentType: type }];
      } catch (err) {
        console.error("fetchAndStoreUrl failed", err);
      }
    },

    async threadconvo(data) {
      try {
        const createData = {
          message: data,
          parent_convo_id: this.getcreatethreaddata?.parent_convo_id || null,
          parent_message_id: this.getcreatethreaddata?.parent_message_id || null,
          type: "thread",
        };

        const createdMessage = await this.createConvo(createData);

    
        this.showallthreadconvos = true;
      } catch (e) {
        console.error("threadconvo error", e);
        eventBus.$emit("alert", "Message failed to send");
      }
    },



    getReminderTooltip(reminders) {
      const list = Array.isArray(reminders) ? reminders : [reminders];
      return list
        .map((r) =>
          r.reminder_date
            ? this.dayjs(r.reminder_date).format("h:mmA M/D/YYYY")
            : ""
        )
        .join("\n");
    },

async openConvo(convo) {
  try {    
   console.log("the opened convo ID:",convo.convo_id);
    const fullThread = this.getSingleThread(convo.convo_id) || convo;
    // Thread-link objects from allthreadconvos don't carry a direct convo_id.
    // Without it, threadMessagesFromStore returns [] and the watcher never fires,
    // so live WS messages never appear in the other tab.
    const threadWithId = {
      ...fullThread,
      convo_id: fullThread.convo_id ?? fullThread.convo_thread_id ?? convo.convo_id,
    };

    this.showallthreadconvos = false;
    this.displayItems = [];

    this.$store.commit("threadconvo/SET_CONVO", threadWithId);
    this.selectedConvo = threadWithId;

    // ----- SHOW PARENT MESSAGE PREVIEW -----
    const parent = convo.parent_message ?? null;

    if (parent) {
      const att = parent.convo_attachments?.[0] || parent.attachments?.[0];

      if (att) {
        const convo_message_id =
          parent.convo_message_id ||
          att.convo_message_id ||
          convo.parent_message_id || null;

        await this.fetchAndStoreUrl(
          convo_message_id,
          att.media_id,
          att.content_type || att.medium?.content_type || ""
        );
      } else if (parent.message && String(parent.message).trim() !== "") {
        this.displayItems = [
          { contentType: "text", text: parent.message }
        ];
      }

      const data = {
        parent_convo_id: parent.convo_id,
        parent_message_id:
          parent.convo_message_id ||
          (att && att.convo_message_id) ||
          convo.parent_message_id ||
          null,
        message: parent.message
      };
      this.PARENTTHREADDATA(data);
    }

    // Ensure convo is in internal convo list
    if (this.setInternalConvos) {
      const list = Array.isArray(this.$store.state.convos.internal_convos)
        ? this.$store.state.convos.internal_convos
        : [];

      if (!list.find(c => c.convo_id === convo.convo_id)) {
        this.setInternalConvos([convo, ...list]);
      }
    }
    await this.$store.dispatch("threadconvo/loadThreadMessages", convo.convo_id);

   this.internalMessages = this.getThreadMessages(convo.convo_id)
  .filter(msg => msg.convo_message_id != null)
  .map(msg => {
    msg.system_process = 'thread_internal';
    return msg;
  });

    this.$nextTick(() => {
      try {
        if (this.$refs.scroller && this.internalMessages.length) {
          this.$refs.scroller.scrollToItem(this.internalMessages.length - 1);
        }
      } catch (e) {
        console.warn("[RightPanel] scrollToItem failed:", e);
      }
    });

  } catch (err) {
    console.error("openConvo error", err);
  }
},

    threadcloseConvo() {
      this.displayItems = [];
      this.selectedConvo = {};
      this.internalMessages = [];
    },

    openallthreadconvos() {
      this.showallthreadconvos = true;
    },

getReferenceMessage(refId) {
  if (!refId) return null;

  let referenceMessage = null;

  this.internalMessages.find((message, idx) => {
    if (message.convo_message_id === refId) {
      referenceMessage = { ...message, index: idx };
      return true;
    }
    return false;
  });

  return referenceMessage;
},

scrollToReference(id) {
  if (!id) return;

  // find message index for scrolling
  const index = this.internalMessages.findIndex(
    (m) => m.convo_message_id === id
  );
  if (index === -1) return;

  if (this.$refs.scroller) {
    this.$refs.scroller.scrollToItem(index, { behavior: "smooth" });
  }

  this.$nextTick(() => {
    setTimeout(() => {
      const el = document.getElementById(`message-${id}`);

      if (el) {
        el.style.backgroundColor = "yellow";
        setTimeout(() => {
          el.style.backgroundColor = "";
        }, 1000);
      }
    }, 120);
  });
},
async deleteConvo(convo) {
  try {
    const convoId = convo.convo_id;

    if (!confirm("Are you sure you want to delete this conversation?")) return;

    // 1. Call backend
    await ConvoService.updateConvoStatus(convoId, { 
      status: false, 
      process: "thread_internal"
    });

    // 2. Update Vuex (remove from list)
    this.$store.commit("threadconvo/REMOVE_THREAD_CONVO", convoId);

    // 3. Reset right panel
    this.backToThreadList();

    eventBus.$emit("alert", {
      message: "Conversation Deleted",
      type: "success-snack",
    });
  } catch (error) {
    console.error(error);
    eventBus.$emit("alert", {
      message: "Failed To Delete Conversation",
      type: "error-snack",
    });
  }
},
    backToThreadList() {
      this.showallthreadconvos = true;
      this.selectedConvo = {};
      this.internalMessages = [];
      this.displayItems = [];
    },
  },

  mounted() {
      this.fetchThreadConvos();
  this.showallthreadconvos = true;
    eventBus.$on("openthreadone", () => {
      this.SHOWCONVORIGHTPANEL(true);
      this.showallthreads = true;
      this.backToThreadList();
    });
// eventBus.$on("reload-thread-messages", convoId => {
//     if (this.selectedConvo?.convo_id === convoId) {
//       this.internalMessages = this.getThreadMessages(convoId).slice();
//     }
//   });
    eventBus.$on("createthreadConvo", async () => {
      if (!this.selectedConvo || typeof this.selectedConvo !== "object") {
        this.selectedConvo = this.convo;
      }
      this.selectedConvo.threadtemporary = true;
      this.internalMessages = [];
      this.showallthreadconvos = false;

      if (this.getcreatethreaddata.convo_attachments) {
        let convo_message_id =
          this.getcreatethreaddata?.parent_message_id || null;
        let media_id =
          this.getcreatethreaddata.convo_attachments.media_id || null;
        let content_type =
          this.getcreatethreaddata.convo_attachments.medium
            .content_type || null;
        await this.fetchAndStoreUrl(
          convo_message_id,
          media_id,
          content_type
        );
      } else {
        this.displayItems = [
          {
            contentType: "text",
            text: this.getcreatethreaddata.message.message,
          },
        ];
      }
    });
  },

  beforeUnmount() {
    eventBus.$off("showthreadconvos");
    eventBus.$off("createthreadConvo");
    this.backToThreadList();
    this.showallthreads = false;
  },
};
</script>

<style scoped>
.break-words {
  word-break: break-word;
}

.thread-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background-color: #f9fafb;
  border-radius: 8px;
  max-height: 500px;
  overflow-y: auto;
}

.thread-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 10px 14px;
  cursor: pointer;
}
.thread-item:hover {
  background-color: #f3f4f6;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
.convo-name {
  font-size: 15px;
  font-weight: 500;
}
.reminder-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.reminder-icon {
  color: #f59e0b;
  font-size: 16px;
}
.show-all-convos-btn {
  background-color: #e5e7eb; /* gray-300 */
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  border: 1px solid #d1d5db;
}

.show-all-convos-btn:hover {
  background-color: #d1d5db; /* gray-300 hover */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.show-all-convos-btn:active {
  background-color: #cbd5e1;
  transform: scale(0.98);
}
.attachment-participant-row {
  display: flex;
  justify-content: center;      /* attachments centered */
  align-items: flex-start;
  position: relative;
  width: 100%;
}

/* Attachments stay centered */
.attachments-center {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}

/* Attachment item */
.attachment-box {
  background-color: #d9f7dc;
  border: 2px solid black;
  border-radius: 8px;
  padding: 10px;
  margin: 5px;
}

.attachment-img {
  height: 30px;
  width: 40px;
  object-fit: cover;
  cursor: pointer;
}

.attachment-pdf {
  display: flex;
  align-items: center;
  color: blue;
  text-decoration: underline;
}

.attachment-video {
  height: 100px;
  width: 200px;
  border-radius: 6px;
}

/* Participants forced to the right */
.participants-right {
  position: absolute;
  right: 10px;
  top: 0;
  text-align: center;
}

/* Row of participants icons */
.participants-row {
  display: flex;
  flex-direction: row-reverse;
  gap: 4px;
}

.participant-avatar {
  margin-left: -8px;
}

.participants-label {
  margin-top: 4px;
  font-size: 12px;
  color: #757575;
  display: flex;
  align-items: center;
  justify-content: center;
}
.highlight-thread .convo-name {
  font-weight: 700 !important;
}
.highlight {
  animation: flash 1s ease-out;
}

@keyframes flash {
  0% { background: yellow; }
  100% { background: transparent; }
}

</style>